import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { CondicaoPagamentoRequest } from '../../requests/financas/condicao-pagamento.request';
import { CondicaoPagamentoResponse } from '../../responses/financas/condicao-pagamento.response';
import { CondicaoPagamentoGetByIdResponse } from '../../responses/financas/condicao-pagamento-get-by-id.response';
import { CondicaoPagamentoLookupResponse } from '../../responses/financas/condicao-pagamento-lookup.response';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root',
})
export class CondicaoPagamentoService extends CommonService {
    private readonly apiUrl: string = environment.urlApiFinancas + 'CondicaoPagamento';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public get(pagina: number = 1, tamanhoPagina: number = 20, nome?: string): Observable<CondicaoPagamentoResponse> {
        let params = new HttpParams()
            .set('pagina', pagina.toString())
            .set('tamanhoPagina', tamanhoPagina.toString());

        if (nome) {
            params = params.set('nome', nome);
        }

        return this.httpClient
            .get<CondicaoPagamentoResponse>(this.apiUrl, { ...this.addHeaderToken(), params })
            .pipe(catchError(this.handleError));
    }

    public getById(id: number): Observable<CondicaoPagamentoGetByIdResponse> {
        const url = `${this.apiUrl}/${id}`;
        return this.httpClient
            .get<CondicaoPagamentoGetByIdResponse>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public getLookup(): Observable<CondicaoPagamentoLookupResponse> {
        const url = `${this.apiUrl}/lookup`;
        return this.httpClient
            .get<CondicaoPagamentoLookupResponse>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public post(request: CondicaoPagamentoRequest): Observable<CondicaoPagamentoGetByIdResponse> {
        return this.httpClient
            .post<CondicaoPagamentoGetByIdResponse>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public put(id: number, request: CondicaoPagamentoRequest): Observable<CondicaoPagamentoGetByIdResponse> {
        const url = `${this.apiUrl}/${id}`;
        return this.httpClient
            .put<CondicaoPagamentoGetByIdResponse>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public bulkDelete(ids: number[]): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/bulk-delete`;
        return this.httpClient
            .post<ReturnStruct>(url, { idsCondicaoPagamento: ids }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
